const NotificationDashboard = () => {
  return <div>Notification Dashboard</div>;
};

export default NotificationDashboard;
